import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { DynamicTemplateStudioPage } from '../features/templates/dynamic-template-studio-page';
import {
  clearTemplateImportDraft,
  peekTemplateImportDraft,
} from '../features/templates/template-import-draft';
export const Route = createFileRoute('/manage/$companySlug/templates_/new/dynamic-html')({
  component: RouteComponent,
});
function RouteComponent() {
  const { companySlug } = Route.useParams();
  // A "From a file" import (see TemplateImportDialog) hands its parsed-but-unsaved
  // draft off through sessionStorage right before navigating here. `peek` (a pure
  // read) is captured once via the lazy state initializer so it survives
  // StrictMode's double-invoke; the key itself is only cleared from the mount
  // effect below, so a later manual refresh of this route starts blank again.
  const [draft] = useState(() => peekTemplateImportDraft());
  useEffect(() => {
    clearTemplateImportDraft();
  }, []);
  return (
    <DynamicTemplateStudioPage companySlug={companySlug} {...(draft ? { initial: draft } : {})} />
  );
}
